export const documentTemplateKeys = {
  lists: () => ['document-templates'] as const,
  list: (params: object) => ['document-templates', params] as const,
  detail: (id: string) => ['document-template', id] as const,
  versions: (id: string) => ['document-template-versions', id] as const,
  versionPage: (id: string, page: number) => ['document-template-versions', id, page] as const,
  version: (id: string, versionId: string) => ['document-template-version', id, versionId] as const,
  variables: () => ['document-variables'] as const,
};
